import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {CustomModal} from '../../../../../../components/CustomModal'
import {TableProductsMini} from './TableProductsMini'

interface Props {
  showModal: boolean
  onCloseModal: () => void
}

export const ModalProductSelection: FC<Props> = (props) => {
  const {showModal, onCloseModal} = props
  const {t} = useTranslation()

  return (
    <CustomModal title={t('Browse')} show={showModal} onHide={onCloseModal}>
      <TableProductsMini onSelectedProduct={onCloseModal} />
    </CustomModal>
  )
}
